import { DyTableColumn } from 'src/app/dynamic/model/dy-model';
import { TOOLTIP_DISCRIPTION_MESSAGES } from '../messages.constant';

export const TABLE_CONFIG_COLUMNS_TRANSACTION_HISTORY: DyTableColumn[] = [
  // { dataKey: 'id', label: 'ID', width: 100, type: 'text' },
  // { dataKey: 'invNo', label: 'Invoice Number', width: 150, type: 'text' },
  {
    dataKey: 'actions',
    label: 'Actions',
    width: 100,
    type: 'action',
    actions: [
      {
        name: 'print',
        iconName: 'print',
      },
      // {
      //   name: 'email',
      //   iconName: 'email',
      // },
      // Task/3424 (Refund Authenticator): left the "refund" column below commented out as it
      // already was (unclear why it was disabled, not something this task should silently
      // re-enable) - this icon action covers both full and partial refunds, matching the concept
      // doc's "first fork: full vs. partial" (transaction-history.component.ts opens a small
      // chooser popup on click). Was previously its own wide text-button column; an icon fits
      // more naturally alongside the other row actions.
      {
        name: 'settlement',
        iconName: 'refund-settlement',
        showHideCondition: 'settlement',
        tooltipDescriptionType: 'action-refund-settlement',
      },
    ],
    alignClass: 'text-start',
  },
  // {
  //   dataKey: 'refund',
  //   label: 'Refund',
  //   width: 200,
  //   type: 'button',
  //   alignClass: 'text-center',
  //   actions: [
  //     {
  //       name: 'refund',
  //     },
  //   ],
  // },
  // {
  //   dataKey: 'void',
  //   label: 'Void',
  //   width: 100,
  //   type: 'button',
  //   alignClass: 'text-center',
  //   actions: [
  //     {
  //       name: 'void',
  //     },
  //   ],
  // },
  {
    dataKey: 'id',
    label: 'Transaction#',
    width: 110,
    type: 'text',
  },
  // {
  //   dataKey: 'receiptId',
  //   label: 'Receipt ID',
  //   width: 150,
  //   type: 'text',
  // },
  {
    dataKey: 'amount',
    label: 'Amount',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'createDate',
    label: 'Processed On',
    width: 200,
    type: 'datetime',
  },
  {
    dataKey: 'sentOn',
    label: 'Sent On',
    width: 200,
    type: 'datetime',
  },
  {
    dataKey: 'paymentMethod',
    label: 'How Collected',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'transactionTypesName',
    label: 'Payment Type',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'note',
    label: 'Note',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'statusValue',
    label: 'Status',
    width: 150,
    type: 'status',
    tooltipDescriptionType: 'status-payment'
  },
  {
    dataKey: 'errorMessage',
    label: 'Failure Reason',
    width: 200,
    type: 'text',
    tooltipDataKey: 'failureReasonTooltip',
    maxLines: 2,
  },
  {
    dataKey: 'writeBackStatusValue',
    label: 'Write Back Status',
    width: 200,
    type: 'status',
    tooltipDescriptionType: 'status-writeback'
  },
  {
    dataKey: 'fixIt',
    label: 'Fix it',
    width: 150,
    type: 'conditionalTextLink',
  },
  {
    dataKey: 'actions',
    label: 'Writeback Actions',
    width: 200,
    type: 'action',
    alignClass: 'text-start',
    actions: [
      {
        name: 'retry',
        iconName: 'black-retry',
        showHideCondition: 'isRetryEnable',
        tooltipDescriptionType: 'action-wb-retry'
      },
      {
        name: 'skip',
        iconName: 'red-no-entry',
        showHideCondition: 'isSkipEnable',
        tooltipDescriptionType: 'action-wb-skip'
      },
      {
        name: 'proceed',
        iconName: 'black-forward',
        showHideCondition: 'isProceedEnable',
        tooltipDescriptionType: 'action-wb-proceed'
      },
    ],
  },
  {
    dataKey: 'writeBackLastRetryOn',
    label: 'Last Retry On',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'writeBackLastRetryBy',
    label: 'Last Retry By',
    width: 200,
    type: 'text',
  },
];

export const TRANSACTION_HISTORY_STATUS_DROPDOWN: any[] = [
  { value: 0, name: 'Link Sent' },
  { value: 1, name: 'Success' },
  { value: 2, name: 'Failed' },
  { value: 3, name: 'Refunded' },
  { value: 4, name: 'Refund Failed' },
];
